import { useEffect, useState } from "react"
import { Backend } from "../services/Backend";
import StripePricingTable from "../components/StripePricingTable";
import { Button, Pagination } from "@mui/material";
import MessageItem from "../components/MessageItem";
import { Link } from "react-router-dom";
import { isUserAdmin, SuccessToast } from "../utils/utils";

export default function MessagesPage(){
  const [messages, setMessages] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const fetchMessages = () => {
    Backend.get(`message?page=${page - 1}`)
      .then(res=> {
        setMessages(res.data);
        setTotalCount(res.totalCount);
      });

  }

  useEffect(() => {
    Backend.put(`message/last-seen`);
  }, []);

  useEffect(() => {
    fetchMessages();
  }, [page]);

  const onDelete = (id) => {
    Backend.delete(`message/${id}`)
      .then(() => {
        SuccessToast("Message deleted");
        fetchMessages();
      });
  }

  const handlePageChange = (event, value) => {
    setPage(value);
  }

  return <div>
    <div className="flex justify-between items-center">
      <h1>Messages</h1>
      {isUserAdmin() && <Link to="/dashboard/messages/new"><Button variant="contained" color="primary" >New message</Button></Link>}
    </div>
    {messages?.map(message => <MessageItem key={message.id} date={message.datetime} message={message.text} onDelete={() => onDelete(message.id)} />)}
    <div className="mt-4"> 
      <Pagination count={Math.ceil(totalCount / 10)} color="primary" page={page} onChange={handlePageChange} />
    </div>
</div>
}